export enum ROLES {
  SUPER_ADMIN = 'superAdmin',
  ADMIN = 'admin',
  USER = 'user',
}

export const ROLES_LIST = Object.values(ROLES).map((role) => role);
